module.exports = __webpack_public_path__ + "media/images/photos/photo-22-b63685970f439fa654eb6b94dfa1c3a3.jpg";